// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SearchResults":"jh_a bik_a bik_j bik_q bik_sv bik_sw bik_w"};